__turbopack_context__.v({
  "main": "MQCmDW_main",
  "root": "MQCmDW_root",
});
